class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.group = this.dataset.groups
    this.productId = this.dataset.productId || this.dataset.rkProductId
    this.productTitle = this.dataset.productTitle

    this.colorSwatchElem = this.querySelector('[data-product-swatches]');
    this.quickAddElems = [...this.querySelectorAll('.product-quickadd')];
    this.productBadgeElem = this.querySelector('.product-badge')

    this.productsData = null;
    this.init();
  }

  init() {
    if (this.group) {
      this.fetchProducts();
    } else {
      this.updateForNonSwatch()
    }
  }

  getQuery(group) {
    return `query @inContext(country: ${Shopify.country}) {
      products(query: "tag:'${group}'", first: 20, sortKey: TITLE) {
        edges {
          node {
            title
            handle
            id
            availableForSale
            tags
            exclude: metafield(namespace: "c_f", key: "exclude_colors_for_online") {value}
            badge: metafield(namespace: "custom_fields", key: "merchandising_message_tag"){value}
            default_color: metafield(namespace: "custom_fields", key: "default_color"){value}
            bundle_setting: metafield(namespace: "custom", key: "bundle_setting"){
              reference {
                ... on Metaobject {
                  id
                  fields {
                    key
                    value
                  }
                }
              }
            }
            media(first: 2) {
              edges {
                node {
                  alt
                  mediaContentType
                  previewImage {
                    url
                  }
                }
              }
            }
            variants(first: 20) {
              edges {
                node {
                  availableForSale
                  price{
                    amount
                  }
                  compareAtPrice
                  {
                    amount
                  }
                  title
                  id
                  sku
                  badge: metafield(namespace: "custom_fields", key: "merchandising_message_tag"){value}
                }
              }
            }
          }
        }
      }
    }`
  }

  fetchProducts() {
    try {
      const query = this.getQuery(this.group)
      fetch(window.api_url, {
        method: 'POST',
        'crossDomain': true,
        
        headers: {
          'X-Shopify-Storefront-Access-Token': window.api_key,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          query: `${query}`
        })
      })
      .then((response) => response.json())
      .then((data) => {
        this.productsData = data?.data?.products?.edges
        if (this.productsData.length > 0) {
          this.buildColorSwatch(this.productsData)
        }
      }).then(() =>{
        
      })
    } catch(err) {
      console.log(err);
    }
  }

  buildColorSwatch(products) {
    let markup = '';
    for(let i=0; i< products.length; i++){
      let product = products[i].node;
      if(product.media.edges.length == 0){
        continue;
      }
      let title = product.variants.edges[0].node.title;
      title = title.substring(0, title.lastIndexOf('/ ') - 1).trim();
      let active = false;
      
      if (product.exclude != null){
        if(product.exclude.value.includes(title)){
          continue;
        }
      } 

      var isFinalSale = false;
      if (product.tags.includes('final-sale')) {
        isFinalSale = true;
      }

      markup += `<button type="button" style="background-image: url(${theme.assetLink}color-${title.toLowerCase().trim().replaceAll(" ", "-").replaceAll('/','-')}_35x.png)" aria-label="${title} color selector" class="color-btn`;
      if (product.id.replace("gid://shopify/Product/","") == this.productId){
        markup += ` active`;
        if (this.productBadgeElem && product.badge != null) {
          this.productBadgeElem.innerHTML = product.badge.value
          this.productBadgeElem.classList.add('show')
        }
      }

      markup+=`" data-url='/products/${product.handle}' data-product-title='${product.title}' data-index='${i}' data-swatch-id='${product.variants.edges[0].node.id.replace("gid://shopify/ProductVariant/", "")}' data-swatch-prd-id='${product.id.replace("gid://shopify/Product/","")}'`;
        if(product.badge != null){markup+= ` data-swatch-badge="${product.badge.value}" `;}
        if(product.default_color != null){markup+= ` data-default-color='${product.default_color.value}' `;}

      markup += ` data-available="${product.availableForSale}" `;

      if (isFinalSale) {
        markup += ` data-is-final-sale="${isFinalSale}" `;
      }

      markup+=`data-swatch-color='${title}' arial-label='${title}' data-price='${product.variants.edges[0].node.price.amount}'`;
      if(product.variants.edges[0].node.compareAtPrice != null){markup += ` data-comp-price='${product.variants.edges[0].node.compareAtPrice.amount}'`;}
      markup+=` data-swatch-image="${product.media.edges[0].node.previewImage.url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_600x$1')}"`;
      if (product.media.edges.length > 1){
        markup+= `data-swatch-image-hover-src="${product.media.edges[1].node.previewImage.url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_600x$1')}"></button>`;
      } else {
        markup+= `data-swatch-image-hover-src="${product.media.edges[0].node.previewImage.url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_600x$1')}"></button>`;
      }
    }

    if (markup) {
      this.colorSwatchElem.innerHTML = markup;
    }

    this.bindEvents();
    // this.hideOOSSize(true);
    if (this.colorSwatchElem.querySelector('.color-btn.active')) {
      this.colorSwatchElem.querySelector('.color-btn.active').click();
    }
  }

  updateForNonSwatch() {
    const notice = this.querySelector('[data-quickadd-notice]')
    if (notice) {
      notice.innerHTML = `${this.productTitle.indexOf('Gift Card') >= 0 ? 'Select Amount' : 'Select a size'}`
    }
  }
  
  handleEmptyColorSwatch() {
    this.quickAddElems.map((element) => {
      element.classList.add('hide')
    })
  }

  bindEvents() {
    this.colorSwatchElem.addEventListener("mouseover",(e)=>{
      let container = e.target.closest(".comp-product-card");
      if(e.target.classList.contains("color-btn")){
        let swatch = e.target;
        container.querySelector(".product-swatch-hover").src = swatch.getAttribute("data-swatch-image");
        container.querySelector(".product-swatch-hover").style.opacity = "1";
      }else{
        container.querySelector(".product-swatch-hover").style.opacity = "0";
        container.querySelector(".product-swatch-hover").src = "";
      }
    })

    this.colorSwatchElem.addEventListener("click",(e) => {
      this.handleColorSwatchClick(e);
      // this.hideOOSSize();
    })

    let queryParams = new URLSearchParams(window.location.search);
    let colorGroup = queryParams.get('filter.p.m.filter.color_group');
    if (colorGroup != null) {
      document.querySelectorAll(".color-btn[data-default-color='"+colorGroup+"']").forEach((e)=>{
        let productMain = e.closest('.comp-product-card').querySelector(".product-card-main");
        let productHover = e.closest('.comp-product-card').querySelector(".product-card-hover");
        productMain.srcset = e.getAttribute("data-swatch-image");
        productMain.dataset.srcset = e.getAttribute("data-swatch-image");
        if (productHover) {
          productHover.srcset = e.getAttribute("data-swatch-image-hover-src");
          productHover.dataset.srcset = e.getAttribute("data-swatch-image-hover-src");
        }
        e.click();
      });
    }
  }

  handleColorSwatchClick(e) {
    if(e.target.classList.contains("color-btn") && this.productsData.length > 0) {
      let container = e.target.closest(".comp-product-card");
      let swatch = e.target;
    
      // Update Active State
      container.querySelectorAll(".color-btn").forEach((e)=>{
        e.classList.remove("active");
      })
      swatch.classList.add("active");
    
      // Update Card Image
      let producMain = container.querySelector(".product-card-main");
      let productHover = container.querySelector(".product-card-hover");
      if (producMain) {
        producMain.srcset = "";
        producMain.src = swatch.getAttribute("data-swatch-image");
      }

      if (productHover) {
        productHover.srcset = "";
        productHover.src = swatch.getAttribute("data-swatch-image-hover-src");
      }
      container.querySelector(".product-url").href = swatch.getAttribute("data-url");
    
      // Build QuickAdd
      let selectedSwatch = this.productsData[swatch.getAttribute("data-index")].node;
      const productId = selectedSwatch.id.replace("gid://shopify/Product/","")
      let markup='';

      for(let i=0; i<selectedSwatch.variants.edges.length; i++){
        let size = selectedSwatch.variants.edges[i].node;
        let title = size.title.indexOf("/")>-1 ? size.title.split("/ ")[1] : size.title;
        markup+=`<li><button type='button' class='quick-add-btn t-link`;
        if(!size.availableForSale){ markup += ` sold-out`;}
        let fullsize;
        if (title == "OS"){
          fullsize = title.replaceAll("OS","One Size");
        }else{
          fullsize = title.replaceAll("X","Extra ").replaceAll("S","Small").replaceAll("M","Medium").replaceAll("L","Large");
        }
        markup+=`' data-quickadd-product-id='${swatch.getAttribute("data-swatch-prd-id")}' data-quickadd-id='${size.id.replace("gid://shopify/ProductVariant/","")}' data-quickadd-product-name='${swatch.getAttribute("data-product-title")}' `;
        // if(!size.availableForSale){ markup += ` disabled `;}
          markup+=`data-quickadd-product-size='${title}' data-variant-sku='${size.sku}' data-variant-dy-price="${size.price.amount}" onclick="ATCDataLayerPLP($(this).data())">${title}</button>
                  <div class="quickadd-info t-caption"> ${fullsize}`
        if(!size.availableForSale){markup+=`<span class="cr-red">(SOLD OUT)</span>`}  
        markup+=`</div></li>`;
      }

      if (this.quickAddElems.length > 0) {
        markup += `
          <li class="quickadd-info t-caption" data-quickadd-notice>${selectedSwatch.title.indexOf('Gift Card') >= 0 ? 'Select Amount' : 'Select a size'}</li>
        `
        this.quickAddElems.map((element) => {
          element.querySelector("ul").innerHTML = markup;
        })
      }

      // Update Price
      const priceElem = container.querySelector('.product-price [data-price]')
      const comparePriceElem = container.querySelector('.product-price [data-compare-price]')
      if (priceElem) {
        const variantPrice = parseFloat(swatch.dataset.price);
        priceElem.innerHTML = formatMoney(variantPrice)
      }

      if (comparePriceElem) {
        const comparePrice = parseFloat(swatch.dataset.compPrice);
        if (typeof swatch.dataset.compPrice == 'undefined') {
          comparePriceElem.classList.add('hide')
        } else {
          comparePriceElem.innerHTML = formatMoney(comparePrice)
          comparePriceElem.classList.remove('hide')
        }
      }

      // Update Product Price Soldout Badge
      const soldoutElement = container.querySelector('.product-price__soldout');
      if (soldoutElement) {
        const available = swatch.dataset.available;
        available == 'true' ? soldoutElement.classList.add('hide') : soldoutElement.classList.remove('hide');
      }

      // Update Final Sale
      const finalSale = swatch.dataset.isFinalSale;
      const elems = [...container.querySelectorAll('.product-final-sale')];
      elems.map((elem) => {
        if (finalSale == 'true') {
          elem.classList.remove('hide')
        } else {
          elem.classList.add('hide')
        }
      })

      // Update Bundle Message
      if (selectedSwatch.bundle_setting != null) {
        const message = selectedSwatch.bundle_setting.reference?.fields.find(f => f.key == 'discount_message')?.value || ''
        const message_mobile = selectedSwatch.bundle_setting.reference?.fields.find(f => f.key == 'discount_message_mobile')?.value || ''

        const messageElem = container.querySelector('[data-product-bundle-msg]');
        const messageElemMobile = container.querySelector('[data-product-bundle-msg-mobile]');

        if (messageElem) {
          messageElem.innerHTML = message
          messageElem.classList.remove('hide')
        }

        if (messageElemMobile) {
          messageElemMobile.innerHTML = message_mobile
          messageElemMobile.classList.remove('hide')
        }
      } else {
        const messageElem = container.querySelector('[data-product-bundle-msg]');
        const messageElemMobile = container.querySelector('[data-product-bundle-msg-mobile]');

        if (messageElem) {
          messageElem.classList.add('hide')
        }

        if (messageElemMobile) {
          messageElemMobile.classList.add('hide')
        }
      }
      
      // Update Badge
      const badgeElem = container.querySelector('.product-badge')
      if (badgeElem) {
        if (typeof swatch.dataset.swatchBadge !== 'undefined') {
          badgeElem.innerHTML = swatch.dataset.swatchBadge
          badgeElem.classList.add('show')
        } else {
          badgeElem.classList.remove('show')
        }
      }

      // Update wishlist ID
      const wishlistButton = container.querySelector('.wk-button-product');
      if (wishlistButton && wishlistButton.classList.contains('wk-add-product')) {
        wishlistButton.setAttribute('data-wk-add-product', productId)
      } else if (wishlistButton && wishlistButton.classList.contains('wk-remove-product')) {
        // wishlistButton.setAttribute('data-wk-remove-product', productId)
      }
    }
  }

  hideOOSSize(trigger = false) {
    const filterOptions = [...document.querySelectorAll('#collection-toolbar input:checked')]
    const sizeButtons = [...this.querySelectorAll('.quick-add-btn.sold-out')]
    let filterValues = [];
    filterOptions.map((option) => {
      filterValues.push(`${option.dataset.value}|||`)
    })

    for (let index = 0; index < sizeButtons.length; index++) {
      const sizeBtn = sizeButtons[index];
      const size = `${sizeBtn.dataset.quickaddProductSize}|||`;

      if (filterValues.includes(size)) {
        sizeBtn.closest('li').classList.add('hide');
        if (trigger) {
          this.triggerOtherSwatch(filterValues)
        }
        break;
      }
    }
  }

  // Enable Other Color swatch which has the filtered option is available
  triggerOtherSwatch(filterValues) {
    let isAvailable = false;
    let targetProductId = null
    for (let i = 0; i < this.productsData.length; i++) {
      const swatch = this.productsData[i].node;
      for(let j = 0; j < swatch.variants.edges.length; j++){
        let size = swatch.variants.edges[j].node;
        let title = size.title.indexOf("/")>-1 ? size.title.split("/ ")[1] : size.title;
        title = `${title}|||`

        if (filterValues.includes(title) && size.availableForSale) {
          isAvailable = true
          targetProductId = swatch.id.replace("gid://shopify/Product/","")
          break;
        }
      }
    }

    if (targetProductId) {
      const targetSwatch = this.querySelector(`.color-btn[data-swatch-prd-id="${targetProductId}"]`);
      if (targetSwatch) {
        targetSwatch.click()
      }
    }
  }
}

if (!customElements.get("product-card")) {
  customElements.define("product-card", ProductCard);
}
